var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { ref: "container", class: [_vm.namespace(), _vm.skinStyle, _vm.cls] },
    [
      _c(
        "select",
        {
          ref: "select",
          class: _vm.classes,
          attrs: { size: _vm.size, disabled: _vm.disabled }
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }